/**
 * ASAP Plumbing — landing page behaviour.
 *
 * Two things: the floating CALL NOW button that appears once the hero has
 * scrolled away, and the footer's legal modals.
 */

/**
 * Floating call button.
 *
 * The design shows it only after the hero leaves the viewport, on the reasoning
 * that the hero already has a call button of its own. An IntersectionObserver
 * on the hero does that without a scroll handler.
 */
function initCallBar() {
	const bar = document.querySelector('[data-asap-call-bar]');

	if (!bar) {
		return;
	}

	const hero = document.querySelector('.asap-hero');

	// No hero on this page (an interior page, say) — then there is nothing to
	// hide behind, so the button is simply always available.
	if (!hero || typeof IntersectionObserver === 'undefined') {
		bar.hidden = false;
		return;
	}

	const observer = new IntersectionObserver(
		([entry]) => {
			bar.hidden = entry.isIntersecting;
		},
		{ threshold: 0.15 }
	);

	observer.observe(hero);
}

/**
 * Legal modals.
 *
 * <dialog>.showModal() brings focus trapping, Escape-to-close, the backdrop and
 * inertness of the page behind it, so none of that is reimplemented here.
 */
function initLegalModals() {
	document.querySelectorAll('[data-asap-modal]').forEach((trigger) => {
		trigger.addEventListener('click', () => {
			const dialog = document.getElementById(trigger.dataset.asapModal);

			if (dialog && typeof dialog.showModal === 'function') {
				dialog.showModal();
			}
		});
	});

	document.querySelectorAll('dialog.asap-modal').forEach((dialog) => {
		dialog.querySelectorAll('[data-asap-modal-close]').forEach((button) => {
			button.addEventListener('click', () => dialog.close());
		});

		// Clicking the backdrop closes it. The click target is the <dialog>
		// itself only when the pointer is outside its own box — anything inside
		// reports one of the children.
		dialog.addEventListener('click', (event) => {
			if (event.target === dialog) {
				dialog.close();
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initCallBar();
	initLegalModals();
});
